<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            {{ isNew ? "Створення типу сервісу" : "Тип сервісу" }}
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="ServiceType"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-form>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12">
                <CustomTextField
                  v-model="title"
                  label="Найменування*"
                  class="ma-1"
                  @input="isChanged = true"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              class="primary-button"
              :disabled="!isValid"
              :loading="loading"
              @click="save"
            >
              Зберегти
            </v-btn>
            <v-btn v-if="!modal" @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import * as serviceTypesApi from "../../../backend/serviceTypesApi.js";

export default {
  props: ["id", "modal"],
  components: {
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  data: () => ({
    title: "",
    loading: false,
    isChanged: false,
  }),
  computed: {
    isValid() {
      return this.title ? true : false;
    },
    isNew() {
      return +this.id ? false : true;
    },
  },
  created() {
    if (+this.id) {
      serviceTypesApi.getServiceType(this.id).then((serviceType) => {
        this.title = serviceType.title;
      });
    }
  },
  methods: {
    save() {
      this.loading = true;

      const serviceType = {
        title: this.title,
      };

      if (!this.isNew) {
        serviceTypesApi
          .updateServiceType(this.id, serviceType)
          .then(() => {
            this.modal ? this.$emit("close") : this.$router.go(-1);
          })
          .finally(() => {
            this.loading = false;
            this.isChanged = false;
          });
      } else {
        serviceTypesApi
          .createServiceType(serviceType)
          .then(() => {
            this.$router.go(-1);
          })
          .finally(() => {
            this.loading = false;
            this.isChanged = false;
          });
      }
    },
  },
};
</script>
